import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom'
import { getOneRosterSchoolUnit } from "../../../store/OneRoster/OneRosterSchoolUnitAction";
import StatusCode from "../../../util/StatusCode";
import * as Helper from '../../../util/Helper';
import TableVertical from '../../misc/TableVertical';
import { RequestState } from "../../../models/RequestState";
import { OneRosterSchoolUnit } from "../../../models/CoreOneRosterModels";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";



const OneRosterSchoolUnitInfo = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { schoolId } = useParams();
    const dispatch = useDispatch();
    const school = useSelector<RootState, RequestState<OneRosterSchoolUnit>>(state => state.onerosterSchoolunit.schoolUnit);

    useEffect(() => {
        if (schoolId !== undefined) {
            getOneRosterSchoolUnit(schoolId)(dispatch);
        }
    }, [dispatch, schoolId]);

    const renderSchoolInfo = () => {
        let schoolInfo = [];
        if (school.code === StatusCode.COMPLETE) {
            const s = school.data;
            schoolInfo.push(
                { header: t('genericTableHeaders.name', { ns: 'common' }), content: s.name, },
                { header: t('commonTableHeaders.sisId', { ns: 'oneRoster' }), content: s.id },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(s.active) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(s.created), classname: 'nowrap' },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(s.modified), classname: 'nowrap' },
                { header: t('schoolUnitTableHeaders.countSections', { ns: 'oneRoster' }), content: <Link to={`/oneroster/class?search=${s.name}`} > {s.classCount}</Link> },
                { header: t('schoolUnitTableHeaders.countTeachers', { ns: 'oneRoster' }), content: <Link to={`/oneroster/user?search=${s.name}&role=teacher`}>{s.teacherCount}</Link> },
                { header: t('schoolUnitTableHeaders.countStudents', { ns: 'oneRoster' }), content: <Link to={`/oneroster/user?search=${s.name}&role=student`}>{s.studentCount}</Link> },
            )
        }
        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'oneRoster' })}
                info={schoolInfo}
                error={school.code === StatusCode.ERROR}
                searching={school.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderSchoolInfo()}
    </>)
}

export default OneRosterSchoolUnitInfo;
